<template>
  <div>
    <LineChart
      v-if="
        chartData &&
        chartData.data &&
        chartData.options &&
        chartData.data.length > 1
      "
      :dataName="id"
      :data="chartData.data"
      :series="chartData.series"
      :options="chartData.options"
    />
  </div>
</template>

<script>
import LineChart from '@/components/shared/charts/LineChart.vue'
import { getLineChartDataForStatItems } from './charts/chart-helpers'

export default {
  name: 'TagTrendsDetails',
  components: {
    LineChart
  },
  props: {
    tags: {
      type: Object,
      default: () => {}
    },
    trendTags: {
      type: Object,
      default: () => {}
    },
    selectedAttributeSegment: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    chartType: {
      type: String,
      default: 'single'
    },
    zeroToHundred: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEnpsTag() {
      return this.firstTag === 'enps' && this.tagNames.length === 1
    },
    isParticipationTag() {
      return this.firstTag === 'participation' && this.tagNames.length === 1
    },
    tagNames() {
      return Object.keys(this.tags)
    },
    firstTag() {
      return this.tagNames[0]
    },
    secondTag() {
      return this.tagNames[1]
    },
    chartData() {
      return getLineChartDataForStatItems({
        statItems: this.tags,
        statItemsTrend: this.trendTags,
        hasLinearRegression: this.hasLinearRegression,
        shouldFormatZeroToHundred: this.shouldFormatZeroToHundred,
        isParticipation: this.isParticipationTag,
        isEnps: this.isEnpsTag,
        tr: this.$tr,
        selectedAttributeSegment: this.selectedAttributeSegment
      })
    },
    hasLinearRegression() {
      return (
        this.chartType === 'single' &&
        this.trendTags[this.firstTag]?.regressionValues?.length > 2
      )
    },
    shouldFormatZeroToHundred() {
      return (
        !!this.zeroToHundred ||
        (this.chartType === 'single' && this.firstTag === 'participation')
      )
    }
  }
}
</script>

<style></style>
